import { GET, POST, PUT, DELETE } from '../lib/axios';
import { fgetUser } from '../lib/Firebase';

const getRestaurantDetails = async (productId) => {
  let header = await getAccessToken();
  return new Promise((resolve, reject) => {
    GET(`ui/v1/menu/${productId}/orderTypes`, header)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error));
  });
};

function getOutletDetails(productId, data) {
  return new Promise((resolve, reject) => {
    POST(`ui/v1/${productId}/getOutlet`, data)
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
}

const getMenuDetails = (productId) => {
  return new Promise((resolve, reject) => {
    GET(`ui/v1/menu/${productId}`)
      .then((response) => resolve(response.data))
      .catch((error) => {
        reject(error);
      });
  });
};

// API for getting business category
//        -> GET ui/v1/menu/:establishmentId/getBusinessCategory
//        params:   info = categories
//                        establishmentId = establishment_id

const getBusinessCategories = (establishmentId) => {
  return new Promise((resolve, reject) => {
    GET(`ui/v1/getAllBusinessCategories`)
      .then((response) => resolve(response.data))
      .catch((error) => {
        reject(error);
      });
  });
};

const getCategories = async (menuId) => {
  let header = await getAccessToken();
  return new Promise((resolve, reject) => {
    GET(`ui/v1/${menuId}/getCategoryData`, header)
      .then((response) => resolve(response.data))
      .catch((error) => {
        reject(error);
      });
  });
};

const getProductBatch = (menuId, catId, batch, itemSize) => {
  return new Promise((resolve, reject) => {
    GET(`ui/v1/menu/${menuId}/categoryItems/${catId}/${batch}/${itemSize}`)
      .then((response) => resolve(response.data))
      .catch((error) => {
        reject(error);
      });
  });
};

const getProducts = (menuId) => {
  return new Promise((resolve, reject) => {
    GET(`ui/v1/menu/${menuId}`)
      .then((response) => resolve(response.data))
      .catch((error) => {
        reject(error);
      });
  });
};

async function UpdatePartialAcceptance(menu_id, order_id, data) {
  let header = await getAccessToken();
  return new Promise((resolve, reject) => {
    POST(
      `/restaurants/v1/${menu_id}/orders/${order_id}/updateEditedOrders`,
      data,
      header
    )
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
}

async function UpdateBot(menu_id, data) {
  return new Promise((resolve, reject) => {
    POST(`/ui/v1/${menu_id}/mapOrdertype`, data)
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
}

async function editStockData(menuId, type, data) {
  let header = await getAccessToken();
  return new Promise((resolve, reject) => {
    POST(`ui/v1/${type}/${menuId}/update`, data, header)
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
}

const getAddressList = (business_type) => {
  return new Promise((resolve, reject) => {
    GET(`ui/v1/${business_type}/getAllAddress`)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error));
  });
};

function addNewAddress(business_type, address) {
  return new Promise((resolve, reject) => {
    POST(`ui/v1/${business_type}/addAddress`, address)
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
}

function newOrderRequest(productId, order) {
  return new Promise((resolve, reject) => {
    POST(`ui/v1/order/${productId}`, order)
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
}

function orderByCash(orderId, order) {
  return new Promise((resolve, reject) => {
    PUT(`ui/v1/order${orderId}/paymentStatus`, order)
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
}

function payOnline(productId, orderId) {
  return new Promise((resolve, reject) => {
    const data = {
      callback_url: window.location.origin + productId,
    };
    POST(`ui/v1/order/${orderId}/paymentLink`, data)
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
}

function updateOnlinePaymentStatus(orderId, data) {
  return new Promise((resolve, reject) => {
    POST(`ui/v1/order/${orderId}/paymentStatus`, data)
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
}
function reserveTable(productId, data) {
  return new Promise((resolve, reject) => {
    POST(`ui/v1/tableRes/${productId}`, data)
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
}
function getQuoteData(locationData) {
  return new Promise((resolve, reject) => {
    POST(`ui/v1/checkDeliveryStatus`, locationData)
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
}

async function getUserAddress(data) {
  let header = await getAccessToken();
  return new Promise((resolve, reject) => {
    POST(`ui/v1/getUserAddress`, data, header)
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
}
async function getDeliveryPartner(data) {
  let header = await getAccessToken();
  return new Promise((resolve, reject) => {
    POST(`ui/v1/getDeliveryPartner`, data, header)
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
}

async function updateOrderType(menuId, data) {
  let header = await getAccessToken();
  return new Promise((resolve, reject) => {
    POST(`ui/v1/${menuId}/updateOrderType`, data, header)
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
}

async function updateReminderStatus(menuId, data) {
  let header = await getAccessToken();
  return new Promise((resolve, reject) => {
    POST(`ui/v1/${menuId}/updateReminderStatus`, data, header)
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
}

function cancelOrderByUser(orderId) {
  return new Promise((resolve, reject) => {
    POST(`ui/v1/cancelOrder/${orderId}`)
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
}

async function acceptOrderByLoc(menuId, orderId) {
  let header = await getAccessToken();
  return new Promise((resolve, reject) => {
    POST(
      `restaurants/v1/${menuId}/orders/${orderId}/acceptOrderByLoc`,
      {},
      header
    )
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
}

async function cancelOrderByLoc(menuId, orderId) {
  let header = await getAccessToken();
  return new Promise((resolve, reject) => {
    POST(
      `restaurants/v1/${menuId}/orders/${orderId}/cancelOrderByLoc`,
      {},
      header
    )
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
}

async function preparationStarted(menuId, orderId) {
  let header = await getAccessToken();
  return new Promise((resolve, reject) => {
    POST(
      `restaurants/v1/${menuId}/orders/${orderId}/preparationStarted`,
      {},
      header
    )
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
}

async function orderDispatched(orderId) {
  let header = await getAccessToken();
  return new Promise((resolve, reject) => {
    POST(
      `deliveryPartners/v1/self_delivery/${orderId}/markPickedUp`,
      {},
      header
    )
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
}

async function orderDelivered(orderId) {
  let header = await getAccessToken();
  return new Promise((resolve, reject) => {
    POST(
      `deliveryPartners/v1/self_delivery/${orderId}/markDelivered`,
      {},
      header
    )
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
}

async function markReady(menuId, orderId) {
  var header = await getAccessToken();
  return new Promise((resolve, reject) => {
    POST(`restaurants/v1/${menuId}/orders/${orderId}/markReady`, {}, header)
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
}

async function markOrderPickedUp(menuId, orderId) {
  var header = await getAccessToken();
  return new Promise((resolve, reject) => {
    POST(`restaurants/v1/${menuId}/orders/${orderId}/markPickedUp`, {}, header)
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
}

function generateOTP({ phoneNumber, recaptchaToken }) {
  return new Promise((resolve, reject) => {
    POST(`ui/v1/otp/send/${phoneNumber}`, { recaptchaToken })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
}
// const getCategories = () => {
//   return new Promise((resolve, reject) => {
//     GET(`ui/v1/GS_FEDEMO/getCategoryURLS`)
//       .then((response) => resolve(response.data))
//       .catch((error) => reject(error));
//   });
// };

function validateOTP({ phoneNumber, OTP }) {
  return new Promise((resolve, reject) => {
    POST(`ui/v1/otp/verify/${phoneNumber}`, { otp: OTP })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
}

const generateGipLink = (botname) => {
  return new Promise((resolve, reject) => {
    GET(`ui/v1/gipLink/${botname}`)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error));
  });
};

const getGipUser = () => {
  return new Promise((resolve, reject) => {
    GET(`ui/v1/getGipUser`)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error));
  });
};

async function loggedIn() {
  let header = await getAccessToken();
  if (header) {
    return new Promise((resolve, reject) => {
      GET(`ui/v1/catalogue/rocketlink`, header)
        .then((response) => resolve(response.data))
        .catch((error) => reject(error));
    });
  }
}

async function getStoreAddress(data, menuId) {
  let header = await getAccessToken();
  if (header) {
    return new Promise((resolve, reject) => {
      POST(`ui/v1/${menuId}/getAllMerchantAddress`, data, header)
        .then((response) => resolve(response.data))
        .catch((error) => reject(error));
    });
  }
}

const loggedOut = () => {
  return new Promise((resolve, reject) => {
    GET(`ui/v1/catalogue/anonrocketlink`)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error));
  });
};

const markNotificationAsRead = (menu_id) => {
  return new Promise((resolve, reject) => {
    GET(`ui/v1/${menu_id}/markNotificationAsRead`)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error));
  });
};

async function getOfferList(menuId) {
  var header = await getAccessToken();
  return new Promise((resolve, reject) => {
    GET(`ui/v1/${menuId}/listOffers`, header)
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
}
async function updateOfferStatus(menu_id, offer_id, data) {
  let header = await getAccessToken();
  return new Promise((resolve, reject) => {
    POST(`ui/v1/${menu_id}/updateOfferStatus/${offer_id}`, data, header)
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
}
async function createOffer(menu_id, data) {
  let header = await getAccessToken();
  return new Promise((resolve, reject) => {
    POST(`ui/v1/${menu_id}/createOffer`, data, header)
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
}
async function listActiveOffers(menu_id) {
  return new Promise((resolve, reject) => {
    GET(`ui/v1/${menu_id}/listActiveOffers`)
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
}

function checkOfferAvailableStatus(menu_id, offer_id, data) {
  return new Promise((resolve, reject) => {
    POST(`ui/v1/${menu_id}/applyOffer/${offer_id}`, data)
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
}
async function updateNotifiedOrderStatus(menu_id, offer_id) {
  let header = await getAccessToken();
  return new Promise((resolve, reject) => {
    PUT(`ui/v1/${menu_id}/updateNotifiedOrderStatus/${offer_id}`, {}, header)
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
}

async function getReminderStatus(menu_id) {
  let header = await getAccessToken();
  if (header) {
    return new Promise((resolve, reject) => {
      GET(`ui/v1/${menu_id}/reminderStatus`, header)
        .then((res) => resolve(res.data))
        .catch((err) => reject(err));
    });
  }
}

async function getOnboardDetails(data) {
  let header = await getAccessToken();
  if (header) {
    return new Promise((resolve, reject) => {
      POST(`ui/v1/getOnboardingDetails`, data, header)
        .then((res) => resolve(res.data))
        .catch((err) => reject(err));
    });
  }
}

async function updateProfile(data) {
  return new Promise((resolve, reject) => {
    POST(`ui/v1/storeUserProfileDetails`, data)
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
}

async function removeAddress(business_type, addressRef) {
  return new Promise((resolve, reject) => {
    DELETE(`ui/v1/${addressRef}/${business_type}/deleteUserAddressDetails`)
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
}

async function getProfileDetails() {
  return new Promise((resolve, reject) => {
    GET(`ui/v1/getUserProfileDetails`)
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
}

async function getMyOrders(menu_id) {
  return new Promise((resolve, reject) => {
    GET(`ui/v1/${menu_id}/getMyOrders`)
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
}

async function getUserDeliveryAddress(business_type, addressRef) {
  return new Promise((resolve, reject) => {
    GET(`ui/v1/${addressRef}/${business_type}/getUserAddressDetails`)
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
}

async function getHelpFromChatBot(menu_id) {
  return new Promise((resolve, reject) => {
    GET(`ui/v1/${menu_id}/help`)
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
}

async function trackOrder(orderId) {
  return new Promise((resolve, reject) => {
    GET(`ui/v1/${orderId}/trackOrder`)
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
}

async function getAccessToken() {
  let token = await fgetUser();
  let header = null;
  if (token) {
    header = { Authorization: 'Bearer ' + token };
  } else {
    token = JSON.parse(localStorage.getItem('authUser'))?.stsTokenManager
      .accessToken;
    header = { Authorization: 'Bearer ' + token };
  }
  return header;
}

async function getSearchSuggestion(
  menu_id,
  searchText,
  pageNmuber = 0,
  limit = 10,
  { food_type, from_price, to_price }
) {
  return new Promise((resolve, reject) => {
    GET(
      `ui/v1/${menu_id}/${pageNmuber}/${limit}/getFilteredItemsFromELK?item_name=${searchText}${
        food_type !== null ? `&food_type=${food_type}` : ''
      }${
        to_price || from_price
          ? `&from_price=${from_price}&to_price=${to_price}`
          : ''
      }`
    )
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
}

export {
  addNewAddress,
  getMenuDetails,
  getBusinessCategories,
  getCategories,
  getProductBatch,
  getProducts,
  UpdateBot,
  editStockData,
  getAddressList,
  getOutletDetails,
  newOrderRequest,
  orderByCash,
  payOnline,
  updateOnlinePaymentStatus,
  getRestaurantDetails,
  reserveTable,
  generateOTP,
  validateOTP,
  getQuoteData,
  getUserAddress,
  getDeliveryPartner,
  updateOrderType,
  acceptOrderByLoc,
  cancelOrderByLoc,
  preparationStarted,
  markReady,
  orderDispatched,
  orderDelivered,
  cancelOrderByUser,
  generateGipLink,
  getGipUser,
  markNotificationAsRead,
  getOfferList,
  updateOfferStatus,
  createOffer,
  listActiveOffers,
  checkOfferAvailableStatus,
  updateNotifiedOrderStatus,
  updateReminderStatus,
  getReminderStatus,
  UpdatePartialAcceptance,
  markOrderPickedUp,
  loggedOut,
  loggedIn,
  getStoreAddress,
  removeAddress,
  updateProfile,
  getProfileDetails,
  getMyOrders,
  getUserDeliveryAddress,
  trackOrder,
  getHelpFromChatBot,
  getSearchSuggestion,
  getOnboardDetails,
};
